const statuses = {
  PENDING: 1,
  DISPATCHED: 2,
  PENDING_ACCEPT: 3,
  IN_PROGRESS: 4,
  IN_FRONT: 5,
  PICKED_UP: 6,
  COMPLETED: 7,
  CANCELLED: 8,
  ASSIGNED: 9
};

module.exports = {

  statuses,

  getStatusId: function (job) {
    return parseInt(job.status_id);
  },

  getJobId: function (job) {
    return parseInt(job.job_id);
  },

  getDriverId: function (job) {
    return parseInt(job.driver_id);
  },

  hasNotStarted: function (job) {
    return this.isPending(job) || this.isDispatched(job) || this.isPendingAcceptance(job) || this.isAssigned(job)
  },

  isPending: function (job) {
    return this.getStatusId(job) === statuses.PENDING;
  },

  isDispatched: function (job) {
    return this.getStatusId(job) === statuses.DISPATCHED;
  },

  isPendingAcceptance: function (job) {
    return this.getStatusId(job) === statuses.PENDING_ACCEPT;
  },

  isInProgress: function (job) {
    return this.getStatusId(job) === statuses.IN_PROGRESS;
  },

  isInFront: function (job) {
    return this.getStatusId(job) === statuses.IN_FRONT;
  },

  isPickedUp: function (job) {
    return this.getStatusId(job) === statuses.PICKED_UP;
  },

  isCompleted: function (job) {
    return this.getStatusId(job) === statuses.COMPLETED;
  },

  isInProgressAndNotCompleted: function (job) {
    return this.getStatusId(job) >= statuses.IN_PROGRESS && this.getStatusId(job) < statuses.COMPLETED;
  },

  isInProgressOrCompleted: function (job) {
    return this.getStatusId(job) >= statuses.IN_PROGRESS && this.getStatusId(job) <= statuses.COMPLETED;
  },

  isPendingOrInProgress: function (job) {
    return this.isPending(job) || this.isInProgressAndNotCompleted(job);
  },

  isCancelled: function (job) {
    return this.getStatusId(job) === statuses.CANCELLED;
  },

  isAssigned: function (job) {
    return this.getStatusId(job) === statuses.ASSIGNED;
  }

};



// WEBPACK FOOTER //
// ./src/components/job/status_service.js